import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginPage } from '@/pages/auth/login/LoginPage'
import { BaseAuthSearchSchema } from '@/schemas/page'

export const Route = createFileRoute('/auth/login')({
  validateSearch: BaseAuthSearchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.authContext.isAuthenticated) {
      return redirect({
        to: search.redirect ?? '/home',
      })
    }
  },
  component: LoginPage,
})
